module.exports = __webpack_public_path__ + "media/assets/images/f-logo-white-3d9b58a3e90cd4ef1524784726292a54.png";